import { ThemeConfig, theme } from '@fuxi/eevee-ui';
import { DarkTheme } from './dark';

const token = theme.getDesignToken({ token: DarkTheme });
export const ComponentsTheme: ThemeConfig['components'] = {
  Button: {
    dangerShadow: undefined,
    primaryShadow: undefined,
    defaultShadow: undefined,
    borderRadius: token.controlHeight,
    borderRadiusLG: token.controlHeightLG,
    borderRadiusSM: token.controlHeightSM,
  },
  Menu: {
    itemHoverBg: 'var(--control-item-bg-hover)',
  },
  Tag: {
    defaultBg: 'rgba(255, 255, 255, 0.2)',
    defaultColor: '#fff',
    colorBorder: 'none',
    borderRadiusSM: 4,
    fontSize: 12,
    paddingXXS: 8,
  },
  Tabs: {
    itemColor: 'var(--color-text-secondary)',
    itemSelectedColor: 'var(--color-text)',
    itemHoverColor: 'var(--color-text)',
  },
  Table: {
    headerBg: '#171724',
    headerColor: 'var(--color-text-secondary)',
    borderColor: 'var(--color-split)',
  },
  Segmented: {
    trackBg: 'var(--color-bg-container)',
    itemSelectedBg: 'var(--color-fill)',
  },
  Select: {
    multipleItemBorderColor: 'var(--color-split)',
    multipleItemBg: 'var(--color-fill-quaternary)',
    multipleItemHeightLG: 36,
    colorBgElevated: 'var(--color-bg-spotlight)',
    optionSelectedColor: token.colorPrimary,
    fontSizeLG: token.fontSize,
  },
  Message: {
    contentBg: 'var(--color-primary-bg)',
    contentPadding: 'var(--padding-md) var(--padding-xl)',
    borderRadiusLG: 100,
    boxShadow: '0px 4px 10px 0px rgba(29, 33, 41, 0.1)',
  },
  Badge: {
    dotSize: 8,
    statusSize: 8,
  },
  Rate: {
    starSize: 20,
    starColor: 'var(--gold-6)',
    starBg: 'var(--color-fill)',
  },
  DatePicker: {
    colorBgElevated: 'var(--color-bg-spotlight)',
    fontSizeLG: token.fontSize,
  },
  Slider: {
    trackBg: 'var(--color-primary)',
    trackHoverBg: 'var(--color-primary)',
    handleColor: 'var(--color-primary)',
    colorPrimaryBorderHover: 'var(--color-primary)',
  },
  Tooltip: {
    // UI 设计：全局的 colorBgSpotlight 与此处不一致
    colorBgSpotlight: '#232340',
  },
  Popconfirm: {
    colorBgElevated: 'var(--color-bg-spotlight)',
  },
  Form: {
    fontSizeLG: token.fontSize,
  },
  Input: {
    fontSizeLG: token.fontSize,
  },
  InputNumber: {
    fontSizeLG: token.fontSize,
  },
};
